import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'

const classNames = new BEMHelper('TileGroup')

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
}

function TileGroup({ className, children }) {
    return <div className={classNames(null, null, className)}>{children}</div>
}

TileGroup.propTypes = propTypes

export default TileGroup
